import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../Workflow.scss'
import { TaskStatus } from '../../../services/TaskStatus';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks } from '../../../services/WorkflowTasks';
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import VerticalNameChildren from '../../../../../components/library/layout/VerticalNameChildren';
import LoadingTextValue from '../../../../../components/library/layout/LoadingTextValue';
import HrbTranslate from '../../../../../components/language/HrbTranslate';
import DateTime from '../../../../../components/library/common/DateTime';
import BlockSignalLink from '../../../../../components/library/common/BlockSignalLink';
import EmdashText from '../../../../../components/library/common/EmdashText';
import Button from '../../../../../components/library/buttons/Button';
import DoxExplorer from '../../dox/Explorer/doxExplorer';

const DocumentUploadTask = (props) => {
    const [baseStatus, completions] = useTaskStatus(props.ticket, [WorkflowTasks.DOCS_UPLOADED]);
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED)
    const [uploadedDate, setUploadedDate] = useState(null)
    const [explorerShowing, setExplorerShowing] = useState(false)

    useEffect(() => {        
        var validCompletion = (completions || []).find(x => x.status !== TaskStatus.INVALID);
        if (!validCompletion || !props.ticket) {
            setUploadedDate(null);
        } else {
            setUploadedDate(validCompletion.lastModified)
        }
    }, [props.ticket])

    useEffect(() => {
        if (baseStatus === TaskStatus.COMPLETE && !uploadedDate) {
            setStatus(TaskStatus.ERROR)
        } else {
            setStatus(baseStatus)
        }
    }, [baseStatus])

    const renderTimestamp = () => {
        if ((baseStatus === TaskStatus.COMPLETE || baseStatus === TaskStatus.IN_PROGRESS) && !uploadedDate) {
            return <HrbTranslate text='DocUploadTask.ErrorTimestamp' params={{ BlockSignal: <BlockSignalLink /> }} className='p2 error' />
        } else {
            return uploadedDate ?
                <p className='p1 medium-weight'><DateTime dateAndTime value={uploadedDate} /></p> :
                <p className='p1 medium-weight'><EmdashText /></p>
        }
    }
    
    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.DOCS_UPLOADED}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    helpKey='0ProSupport/VDOPro/ClientDocuments.htm'
                    descriptions={baseStatus === TaskStatus.NOT_STARTED
                        ? ['DocUploadTask.DescriptionAlt']
                        : ['DocUploadTask.Description']} />
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-4'>
                    <h4><LoadingTextValue loading={!props.ticket} value={`${props.ticket.taxYear}`} /></h4>
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <VerticalNameChildren
                        textKey="DocUploadTask.LastDocUpload"
                        loading={!props.ticket}>
                        {renderTimestamp()}
                    </VerticalNameChildren>
                </div>
            </div>
            <div className='columns'>
                <div className='column is-10 is-offset-1'>
                    <div className='step-center-container'>
                    {props.ticket && 
                        <Button
                            loading={false}
                            elementId='ticket-viewmanage-btn'
                            labelKey='DocUploadTask.ViewManage'
                            buttonStyles='secondary'
                            disabled={false}
                            onClick={() => setExplorerShowing(true)} />
                        }
                    </div>
                </div>
            </div>
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={() => setExplorerShowing(false)}
            />
        </WorkflowTask>
    );
}

DocumentUploadTask.whyDidYouRender = false;

DocumentUploadTask.propTypes = {
    ticket: PropTypes.object
}

export default DocumentUploadTask